import { ORDER_STATUSES } from '@/utils/Constants';

// типы заказов
export const PRIORITY_TYPES = {
  // срочный заказ
  URGENT: 'urgent',
  // обычный
  NORMAL: 'normal',
};

export const URGENT_ASSIGN_TYPES = {
  ASSIGNED: 'assigned',
  NOTASSIGNED: 'notassigned',
};

export const GAG_TYPE = {
  meta: 'cancel_day_cc',
  metaHelper: '',
  header: '',
  headerHelper: '',
  metaFormat({ i18n, freeUntilDate }) {
    return `${i18n(this.meta)} ${freeUntilDate}`;
  },
};

// Текущие обычные
export const NORMAL_TYPES = {
  /** 100% оплата, бесплатная отмена */
  PAY_CARD_FREE_CANCEL: 'pay_card_free_cancel',
  /** 100% оплата, отмена со штрафом */
  PAY_CARD_REFUND_CANCEL: 'pay_card_refund_cancel',
  /** частичная, бесплатная отмена */
  PAY_PARTIAL_FREE_CANCEL: 'pay_partial_free_cancel',
  /** частичная, отмена со штрафом */
  PAY_PARTIAL_REFUND_CANCEL: 'pay_partial_refund_cancel',
  /** полная наличными с превязкой карты, бесплатная отмена */
  PAY_DRIVER_CARD_FREE_CANCEL: 'pay_driver_card_free_cancel',
  /** полная наличными с превязкой карты, отмена со штрафом */
  PAY_DRIVER_CARD_REFUND_CANCEL: 'pay_driver_card_refund_cancel',
  /** полная наличными без превязки карты, бесплатная отмена */
  PAY_DRIVER_NOCARD_FREE_CANCEL: 'pay_driver_nocard_free_cancel',
  /** полная наличными без превязки карты, отмена со штрафом */
  PAY_DRIVER_NOCARD_REFUND_CANCEL: 'pay_driver_nocard_refund_cancel',
  /** оплата с баланса, бесплатная отмена */
  PAY_BALANCE_FREE_CANCEL: 'pay_balance_free_cancel',
  /** оплата с баланса, отмена со штрафом */
  PAY_BALANCE_REFUND_CANCEL: 'pay_balance_refund_cancel',
  /** частичная оплата с баланса, бесплатная отмена */
  PAY_PARTIAL_BALANCE_FREE_CANCEL: 'pay_partial_balance_free_cancel',
  /** частичная оплата с баланса, отмена со штрафом */
  PAY_PARTIAL_BALANCE_REFUND_CANCEL: 'pay_partial_balance_refund_cancel',
};

// Текущие срочные
export const URGENT_TYPES = {

  /**
   * Assigned
   */

  /** Назначенный, 100% оплата, бесплатная отмена */
  PAY_CARD_ASSIGNED_FREE_CANCEL: 'pay_card_assigned_free_cancel',
  /** Назначенный, 100% оплата, отмена со штрафом */
  PAY_CARD_ASSIGNED_REFUND_CANCEL: 'pay_card_assigned_refund_cancel',
  /** Назначенный, частичная, бесплатная отмена */
  PAY_PARTIAL_ASSIGNED_FREE_CANCEL: 'pay_partial_assigned_free_cancel',
  /** Назначенный, частичная, отмена со штрафом */
  PAY_PARTIAL_ASSIGNED_REFUND_CANCEL: 'pay_partial_assigned_refund_cancel',
  /** Назначенный, полная наличными без превязки карты, бесплатная отмена */
  PAY_DRIVER_NOCARD_ASSIGNED_FREE_CANCEL: 'pay_driver_nocard_assigned_free_cancel',
  /** Назначенный, полная наличными без превязки карты, отмена со штрафом */
  PAY_DRIVER_NOCARD_ASSIGNED_REFUND_CANCEL: 'pay_driver_nocard_assigned_refund_cancel',
  /** Назначенный, оплата с баланса, бесплатная отмена */
  PAY_BALANCE_ASSIGNED_FREE_CANCEL: 'pay_balance_assigned_free_cancel',
  /** Назначенный, оплата с баланса, отмена со штрафом */
  PAY_BALANCE_ASSIGNED_REFUND_CANCEL: 'pay_balance_assigned_refund_cancel',
  /** Назначенный, частичная оплата с баланса, бесплатная отмена */
  PAY_PARTIAL_BALANCE_ASSIGNED_FREE_CANCEL: 'pay_partial_balance_assigned_free_cancel',
  /** Назначенный, частичная оплата с баланса, отмена со штрафом */
  PAY_PARTIAL_BALANCE_ASSIGNED_REFUND_CANCEL: 'pay_partial_balance_assigned_refund_cancel',

  /**
   * Not Assigned
   */

  /** Неназначенные, 100% оплата */
  PAY_CARD_NOTASSIGNED: 'pay_card_notassigned',
  /** Неназначенные, частичная оплата */
  PAY_PARTIAL_NOTASSIGNED: 'pay_partial_notassigned',
  /** Неназначенные, полная наличными */
  PAY_DRIVER_NOTASSIGNED: 'pay_driver_notassigned',
  /** Неназначенные, оплата с баланса */
  PAY_BALANCE_NOTASSIGNED: 'pay_balance_notassigned',
  /** Неназначенные, частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_NOTASSIGNED: 'pay_partial_balance_notassigned',
  /**
   * Past bookings
  */
};

// прошлые заказы
export const PAST_TYPES = {
  /** Исполненный 100% картой */
  PAY_CARD_COMPLETED: 'pay_card_completed',
  /** Исполненный частичная оплата */
  PAY_PARTIAL_COMPLETED: 'pay_partial_completed',
  /** Исполненный наличными водителю с привязкой карты */
  PAY_DRIVER_CARD_COMPLETED: 'pay_driver_card_completed',
  /** Исполненный наличными водителю без привязки карты */
  PAY_DRIVER_NOCARD_COMPLETED: 'pay_driver_nocard_completed',
  /** Исполненный оплата с баланса */
  PAY_BALANCE_COMPLETED: 'pay_balance_completed',
  /** Исполненный частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_COMPLETED: 'pay_partial_balance_completed',

  /** Проваленынй 100% картой */
  PAY_CARD_FAILED: 'pay_card_failed',
  /** Проваленынй частичная оплата */
  PAY_PARTIAL_FAILED: 'pay_partial_failed',
  /** Проваленынй наличными водителю с привязкой карты */
  PAY_DRIVER_CARD_FAILED: 'pay_driver_card_failed',
  /** Проваленынй наличными водителю без привязки карты */
  PAY_DRIVER_NOCARD_FAILED: 'pay_driver_nocard_failed',
  /** Проваленный оплата с баланса */
  PAY_BALANCE_FAILED: 'pay_balance_failed',
  /** Проваленный частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_FAILED: 'pay_partial_balance_failed',

  /** ОТМЕНЕННЫЙ бесплатно 100% оплата картой */
  PAY_CARD_FREE_CANCELED: 'pay_card_free_canceled',
  /** ОТМЕНЕННЫЙ платно 100% оплата картой */
  PAY_CARD_REFUND_CANCELED: 'pay_card_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно частичная оплата картой */
  PAY_PARTIAL_FREE_CANCELED: 'pay_partial_free_canceled',
  /** ОТМЕНЕННЫЙ платно частичная оплата картой */
  PAY_PARTIAL_REFUND_CANCELED: 'pay_partial_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно cрочный заказ 100% оплата картой */
  PAY_CARD_URGENT_FREE_CANCELED: 'pay_card_urgent_free_canceled',
  /** ОТМЕНЕННЫЙ платно cрочный заказ 100% оплата картой */
  PAY_CARD_URGENT_REFUND_CANCELED: 'pay_card_urgent_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно cрочный заказ частичная оплата картой */
  PAY_PARTIAL_URGENT_FREE_CANCELED: 'pay_partial_urgent_free_canceled',
  /** ОТМЕНЕННЫЙ платно cрочный заказ частичная оплата картой */
  PAY_PARTIAL_URGENT_REFUND_CANCELED: 'pay_partial_urgent_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно 100% оплата наличными, привязка карты */
  PAY_DRIVER_CARD_FREE_CANCELED: 'pay_driver_card_free_canceled',
  /** ОТМЕНЕННЫЙ платно 100% оплата наличными, привязка карты */
  PAY_DRIVER_CARD_REFUND_CANCELED: 'pay_driver_card_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно 100% оплата наличными,
  * без привязки карты (санкционный регион и пр.)
  */
  PAY_DRIVER_NOCARD_FREE_CANCELED: 'pay_driver_nocard_free_canceled',
  /** ОТМЕНЕННЫЙ платно 100% оплата наличными,
  * без привязки карты (санкционный регион и пр.)
  */
  PAY_DRIVER_NOCARD_REFUND_CANCELED: 'pay_driver_nocard_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно оплата с баланса */
  PAY_BALANCE_FREE_CANCELED: 'pay_balance_free_canceled',
  /** ОТМЕНЕННЫЙ платно оплата с баланса */
  PAY_BALANCE_REFUND_CANCELED: 'pay_balance_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно cрочный заказ оплата с баланса */
  PAY_BALANCE_URGENT_FREE_CANCELED: 'pay_balance_urgent_free_canceled',
  /** ОТМЕНЕННЫЙ платно cрочный заказ оплата с баланса */
  PAY_BALANCE_URGENT_REFUND_CANCELED: 'pay_balance_urgent_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_FREE_CANCELED: 'pay_partial_balance_free_canceled',
  /** ОТМЕНЕННЫЙ платно частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_REFUND_CANCELED: 'pay_partial_balance_refund_canceled',

  /** ОТМЕНЕННЫЙ бесплатно cрочный заказ частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_URGENT_FREE_CANCELED: 'pay_partial_balance_urgent_free_canceled',
  /** ОТМЕНЕННЫЙ платно cрочный заказ частичная оплата с баланса */
  PAY_PARTIAL_BALANCE_URGENT_REFUND_CANCELED: 'pay_partial_balance_urgent_refund_canceled',
};

export const READABLE_BOOKING_STATUSES = {
  URGENT_NOTASSIGNED: {
    [ORDER_STATUSES.CONFIRMATION_WAITING]: 'processing_status_cc',
    [ORDER_STATUSES.CONFIRMED]: 'processing_status_cc',
    [ORDER_STATUSES.REFUSE]: 'need_clarify_status_cc',
  },
  URGENT_ASSIGNED: 'ready_status_cc',
  NORMAL: {
    [ORDER_STATUSES.CONFIRMATION_WAITING]: 'processing_status_cc',
    [ORDER_STATUSES.CONFIRMED]: 'processing_status_cc',
    [ORDER_STATUSES.REFUSE]: 'need_clarify_status_cc',
    [ORDER_STATUSES.READY]: 'ready_status_cc',
  },
  COMPLETED: 'completed_status_cc',
  FAILED: 'failed_status_cc',
  CANCELED: 'canceled_status_cc',
};

export const URGENT_TYPE_HELPERS = {

  /**
   * Assigned
   */

  // 100% предоплата картой
  [URGENT_TYPES.PAY_CARD_ASSIGNED_FREE_CANCEL]: withInsurance => ({
    meta: withInsurance ? 'free_cancel_add_cc' : 'free_cancel_day_time_cc',
    metaHelper: withInsurance ? '' : 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return withInsurance
        ? `${i18n(this.meta)}`
        : `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [URGENT_TYPES.PAY_CARD_ASSIGNED_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // Частичная предоплата
  [URGENT_TYPES.PAY_PARTIAL_ASSIGNED_FREE_CANCEL]: withInsurance => ({
    meta: withInsurance ? 'free_cancel_add_cc' : 'free_cancel_day_time_cc',
    metaHelper: withInsurance ? '' : 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return withInsurance
        ? `${i18n(this.meta)}`
        : `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [URGENT_TYPES.PAY_PARTIAL_ASSIGNED_REFUND_CANCEL]: withInsurance => ({
    meta: withInsurance ? 'free_cancel_add_cc' : 'cancellation_fine_cc',
    metaHelper: withInsurance ? '' : 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return withInsurance
        ? `${i18n(this.meta)}`
        : `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // 100% оплата наличными
  [URGENT_TYPES.PAY_DRIVER_NOCARD_ASSIGNED_FREE_CANCEL]: () => ({
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  }),
  [URGENT_TYPES.PAY_DRIVER_NOCARD_ASSIGNED_REFUND_CANCEL]: () => ({
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  }),

  // оплата с баланса
  [URGENT_TYPES.PAY_BALANCE_ASSIGNED_FREE_CANCEL]: () => ({
    meta: 'free_cancel_day_time_cc',
    metaHelper: 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [URGENT_TYPES.PAY_BALANCE_ASSIGNED_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  }),

  // Частичная предоплата с баланса
  [URGENT_TYPES.PAY_PARTIAL_BALANCE_ASSIGNED_FREE_CANCEL]: () => ({
    meta: 'free_cancel_day_time_cc',
    metaHelper: 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  }),
  [URGENT_TYPES.PAY_PARTIAL_BALANCE_ASSIGNED_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  }),

  /**
   * Not Assigned
   */

  [URGENT_TYPES.PAY_CARD_NOTASSIGNED]: () => ({
    meta: '',
    metaHelper: '',
    header: 'find_car_urgent_cc',
    headerHelper: 'find_car_urgent_prerpay_helper_cc',
    readableStatus: 'ожидание/требует уточнения',
    metaFormat() {},
  }),
  [URGENT_TYPES.PAY_PARTIAL_NOTASSIGNED]: () => ({
    meta: '',
    metaHelper: '',
    header: 'find_car_urgent_cc',
    headerHelper: 'find_car_urgent_prerpay_helper_cc',
    metaFormat() {},
  }),
  [URGENT_TYPES.PAY_DRIVER_NOTASSIGNED]: () => ({
    meta: '',
    metaHelper: '',
    header: 'find_car_urgent_cc',
    headerHelper: 'find_car_urgent_noprepay_helper_cc',
    metaFormat() {},
  }),
  [URGENT_TYPES.PAY_BALANCE_NOTASSIGNED]: () => ({
    meta: '',
    metaHelper: '',
    header: 'find_car_urgent_cc',
    headerHelper: 'find_car_urgent_prerpay_helper_cc',
    readableStatus: 'ожидание/требует уточнения',
    metaFormat() {},
  }),
  [URGENT_TYPES.PAY_PARTIAL_BALANCE_NOTASSIGNED]: () => ({
    meta: '',
    metaHelper: '',
    header: 'find_car_urgent_cc',
    headerHelper: 'find_car_urgent_prerpay_helper_cc',
    metaFormat() {},
  }),

};

export const NORMAL_TYPE_HELPERS = {
  // 100% оплата картой
  [NORMAL_TYPES.PAY_CARD_FREE_CANCEL]: withInsurance => ({
    meta: withInsurance ? 'free_cancel_add_cc' : 'free_cancel_day_time_cc',
    metaHelper: withInsurance ? '' : 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return withInsurance
        ? `${i18n(this.meta)}`
        : `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [NORMAL_TYPES.PAY_CARD_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // Частичная предоплата (часть картой, часть наличными)
  [NORMAL_TYPES.PAY_PARTIAL_FREE_CANCEL]: withInsurance => ({
    meta: withInsurance ? 'free_cancel_add_cc' : 'free_cancel_day_time_cc',
    metaHelper: withInsurance ? '' : 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return withInsurance
        ? `${i18n(this.meta)}`
        : `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [NORMAL_TYPES.PAY_PARTIAL_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // 100% оплата наличными, привязка карты
  [NORMAL_TYPES.PAY_DRIVER_CARD_FREE_CANCEL]: () => ({
    meta: 'free_cancel_day_time_cc',
    metaHelper: 'if_cancel_charge_card_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [NORMAL_TYPES.PAY_DRIVER_CARD_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'charge_card_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // 100% оплата наличными, без привязки карты (санкционный регион, ошибка оплаты и пр.)
  [NORMAL_TYPES.PAY_DRIVER_NOCARD_FREE_CANCEL]: (withInsurance, hoursBeforeStart) => ({
    meta: '',
    metaHelper: '',
    header: hoursBeforeStart > 36 ? 'call_confirmation_cc' : 'need_confirmation_cc',
    headerHelper: 'cancellation_no_confirmation_helper_cc',
    metaFormat() {},
  }),
  [NORMAL_TYPES.PAY_DRIVER_NOCARD_REFUND_CANCEL]: (withInsurance, hoursBeforeStart) => ({
    meta: '',
    metaHelper: '',
    header: hoursBeforeStart > 36 ? 'call_confirmation_cc' : 'need_confirmation_cc',
    headerHelper: 'cancellation_no_confirmation_helper_cc',
    metaFormat() {},
  }),

  // оплата с баланса
  [NORMAL_TYPES.PAY_BALANCE_FREE_CANCEL]: () => ({
    meta: 'free_cancel_day_time_cc',
    metaHelper: 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [NORMAL_TYPES.PAY_BALANCE_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),

  // Частичная предоплата с баланса
  [NORMAL_TYPES.PAY_PARTIAL_BALANCE_FREE_CANCEL]: () => ({
    meta: 'free_cancel_day_time_cc',
    metaHelper: 'if_cancel_no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, freeUntilDate }) {
      return `${i18n(this.meta)} ${freeUntilDate}`;
    },
  }),
  [NORMAL_TYPES.PAY_PARTIAL_BALANCE_REFUND_CANCEL]: () => ({
    meta: 'cancellation_fine_cc',
    metaHelper: 'no_refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n, currency, cancellationPenaltyAmount }) {
      return `${i18n(this.meta)} ${currency}&#160;${cancellationPenaltyAmount.toFixed(2)}`;
    },
  }),
};

export const PAST_TYPES_HELPERS = {
  [PAST_TYPES.PAY_CARD_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_PARTIAL_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_DRIVER_CARD_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_DRIVER_NOCARD_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_BALANCE_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_PARTIAL_BALANCE_COMPLETED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_CARD_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_PARTIAL_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_DRIVER_CARD_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_DRIVER_NOCARD_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_BALANCE_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_PARTIAL_BALANCE_FAILED]: {
    meta: '',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat() {},
  },

  [PAST_TYPES.PAY_CARD_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_CARD_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_PARTIAL_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_PARTIAL_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_CARD_URGENT_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_CARD_URGENT_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_PARTIAL_URGENT_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'refund_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_PARTIAL_URGENT_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_DRIVER_CARD_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  },
  [PAST_TYPES.PAY_DRIVER_CARD_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_charge_card_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_DRIVER_NOCARD_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  },
  [PAST_TYPES.PAY_DRIVER_NOCARD_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}`;
    },
  },

  [PAST_TYPES.PAY_BALANCE_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_BALANCE_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_BALANCE_URGENT_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_BALANCE_URGENT_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_PARTIAL_BALANCE_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_PARTIAL_BALANCE_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },

  [PAST_TYPES.PAY_PARTIAL_BALANCE_URGENT_FREE_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: '',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)} ${i18n('after_cancel_refund_cc')}`;
    },
  },
  [PAST_TYPES.PAY_PARTIAL_BALANCE_URGENT_REFUND_CANCELED]: {
    meta: 'cancel_day_cc',
    metaHelper: 'cancellation_fine_helper_cc',
    header: '',
    headerHelper: '',
    metaFormat({ i18n }) {
      return `${i18n(this.meta)}${i18n('after_cancel_fine_cc')}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/bookingTypes/constants.js